import { types } from "mobx-state-tree";

export const ReviewStore = types.model({
  id: types.identifierNumber,

  star: types.optional(types.number, 0),
  content: types.optional(types.string, ""),

  teacher_star: types.optional(types.number, 0),
  teacher_content: types.maybeNull(types.string),
});
